import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';


const httpOptions = {
  headers: new HttpHeaders(
    { 'Content-Type': 'application/json', 
      'Access-Control-Allow-Origin' : '*' },   
    
    ) 
};

@Injectable()
export class RegApiService {

  pdfBlob: Blob | null = null;
  pdfBlobUrl: any;
  private getEstimatedMonthlyPremiumRequestUrlE2ESoleProprietor: string = environment.registrationApiUrl + '/api/v1/E2ESoleProp/GetSolePropEstimatedMonthlyPremium';
  private getPOPThresholdValuesUrlE2ESoleProprietor =  environment.registrationApiUrl + '/api/v1/E2ESoleProp/GetSolePropThresholdValues?popCoveragStartDate=';
  private getClassificationBySearchCriteriaUrl: string = environment.registrationApiUrl + '/api/v1/ClassificationInfo/ClassificationBySearchCriteria';
  private solePropPayrollValidateUrl: string = environment.registrationApiUrl + '/api/v1/E2ESoleProp/SolePropPayrollValidate';
  private sendMessageToSubmissionTopicUrl: string = environment.registrationApiUrl + '/api/v1/Info/SendMessageToSubmissionTopic';
  private sendMessageToRequestTopicUrl: string = environment.registrationApiUrl + '/api/v1/Info/SendMessageToRequestTopic';
  private getSubmittedPacificStandardTimeUrl: string = environment.registrationApiUrl + '/api/v1/E2E/GetSubmittedPacificStandardTime';

  constructor(
    private http: HttpClient
  ) { }


  getSolePropEstimatedMonthlyPremium(dto: any): Observable<any> {
    try {    
      return this.http.post<any>(this.getEstimatedMonthlyPremiumRequestUrlE2ESoleProprietor, dto, httpOptions);
    } catch (error) {     
      console.error('[RegApiService] getSolePropEstimatedMonthlyPremium:', error);
      throw error; // Re-throw the error to handle it in the component
    } 
  }

  getSolePropThresholdValues(popCoveragStartDate: any): Observable<any> {
    try {    
      return this.http.get<any>(this.getPOPThresholdValuesUrlE2ESoleProprietor + popCoveragStartDate, httpOptions);
    } catch (error) {     
      console.error('[RegApiService] getPOPThresholdValues:', error);
      throw error; 
    } 
  }

  
  getClassificationBySearchCriteria(dto: any): Observable<any> {
    try {    
      return this.http.post<any>(this.getClassificationBySearchCriteriaUrl, dto, httpOptions);
    } catch (error) {     
      console.error('[RegApiService] getClassificationBySearchCriteria:', error);
      throw error; 
    } 
  }

  solePropPayrollValidate(dto: any): Observable<any> {
    try {    
      return this.http.post<any>(this.solePropPayrollValidateUrl, dto, httpOptions);
    } catch (error) {     
      console.error('[RegApiService] solePropPayrollValidate:', error);
      throw error; 
    } 
  }

  
  sendMessageToSubmissionTopic(): Observable<any> {
    try {    
      return this.http.post<any>(this.sendMessageToSubmissionTopicUrl, null, httpOptions);
    } catch (error) {     
      console.error('[RegApiService] sendMessageToSubmissionTopic:', error);
      throw error; 
    } 
  }

  
  sendMessageToRequestTopic(): Observable<any> {
    try {    
      return this.http.post<any>(this.sendMessageToRequestTopicUrl, null, httpOptions);
    } catch (error) {     
      console.error('[RegApiService] sendMessageToRequestTopic:', error);
      throw error; 
    } 
  }

  getSubmittedPacificStandardTime(dto: any): Observable<any> {
    try {    
      return this.http.post<any>(this.getSubmittedPacificStandardTimeUrl, dto, httpOptions);
    } catch (error) {     
      console.error('[RegApiService] getSubmittedPacificStandardTime:', error);
      throw error; 
    } 
  }

}
